import $ from 'jquery';
import whatInput from 'what-input';

window.$ = $;

import Foundation from 'foundation-sites';
// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';


$(document).foundation();

$(window).on("scroll", function() {
    if($(window).scrollTop() > 150) {
        $(".top-bar").addClass("active");
    } else {
       $(".top-bar").removeClass("active");
    }
});

$(document).ready(function(){

  // hide #back-top first
  $("#back-top").hide();

  // fade in #back-top
  $(function () {
    $(window).scroll(function () {
      if ($(this).scrollTop() > 200) {
        $('#back-top').fadeIn();
      } else {
        $('#back-top').fadeOut();
      }
    });

    // scroll body to 0px on click
    $('#back-top .fi-arrow-up').click(function () {
      $('body,html').animate({
        scrollTop: 0
      }, 800);
      return false;
    });
  });
});
    
$(document).ready(function(){
    
    $('form').submit(function(e) {
	
	if($('form')[0].valid.value.length == 0 || $('form')[0].email.value.substr(-1) != $('form')[0].valid.value) {
	    $('#valid').css('border-color', 'red')
	    e.preventDefault()
	    return false
	}
    })
    
});
